import * as React from "react";
import {translate} from "react-i18next";
import i18n from "i18next";
import {Header} from "../../components/Header";
import TextBody from "../../components/TextBody";
import BottomBar from "../../components/BottomBar";
import TopNav from "../../components/TopNav";
import {UncontrolledCarousel,Container,Row,Col} from "reactstrap";
import StatusOverview from "../../components/StatusBar";
import vodafoneLogo from "../../media/icons/vf-logo.png";
import {SpacerRow} from "../../components/SpacerRow";
import {BrowserView,MobileView,isMobile} from "react-device-detect";
import InfoBlocks from "../../components/InfoBlocks";
import SingleButton from "../../components/SingleButton";
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import moment from "moment";

class StageTAM6002Apl03 extends React.Component {

    constructor(props){
        super(props);
        // console.log( "FNX: Stage0Welcome props");
        // console.log(props);
        this.state = { selectedOption: '' }
    }

    handleOnChange = (e) =>  {
        console.log('selected option', e.target.value);
        this.setState({ selectedOption: e.target.value});
    }

    /**
     * render
     * @returns {*}
     */
    render() {
        return <Container>

			<MobileView>
				<Row className={"header"}>
					<Col xs={2} style={{marginLeft:"-15px"}}>
						<img src={vodafoneLogo} className={"img-fluid"}  alt={"Vodafone Logo"}/>
					</Col>
				</Row>
				<Row style={{paddingTop:"5vh"}}>
					<Col xs={{ size: 12 }}>
						<Header
							textResource={"apl_3_title"}
						/>
					</Col>
				</Row>
				<Row style={{paddingTop:"20px"}}>
					<Col xs={{ size: 12 }}>
						<TextBody
							textResource={"apl_3_body_1"}
						/>
					</Col>
				</Row>
				<Row>
					<Col xs={{ size: 12 }}>
						<TextBody
							textResource={"apl_3_body_2"}
							emoji_key = "&#128273;"
						/>
					</Col>
				</Row>
				<Row className={'fixed-to-bottom'} style={{paddingBottom:"20px"}}>
					<Col xs={{ size: 12 }}>
						<BottomBar
							// mainButtonOnClick={this.props.nextStage}
							mainButtonOnClick={() => {
								// const proposalDate = moment(this.props.ds360APIResult.proposalDate);
								// const isoSelectedDate = moment(this.state.selectedDate);
								this.props.commonSubmitCallback(this.state.selectedOption)
							}}
							mainButtonTextResource={"ok"}
						/>
					</Col>
				</Row>
			</MobileView>

			<BrowserView>
				<Row className={"header desktop"}>
					<Col xs={12}>
						<div className={"container"}>
							<Row>
								<Col xs={2} style={{marginLeft:"-15px"}}>
									<img src={vodafoneLogo} className={"img-fluid"}  alt={"Vodafone Logo"}/>
								</Col>
							</Row>
						</div>
					</Col>
				</Row>
				<Row style={{paddingTop:"20vh"}}>
					<Col xs={{ size: 10, offset: 1 }}>
						<Header
							textResource={"apl_3_title"}
						/>
					</Col>
				</Row>
				<Row style={{paddingTop:"20px"}}>
					<Col xs={{ size: 10, offset: 1 }}>
						<TextBody
							textResource={"apl_3_body_1"}
						/>
					</Col>
				</Row>
				<Row>
					<Col xs={{ size: 10, offset: 1 }}>
						<TextBody
							textResource={"apl_3_body_2"}
							emoji_key = "&#128273;"
						/>
					</Col>
				</Row>
				<Row>
					<Col xl={{ size: 3, offset: 1 }} lg={{ size: 3, offset: 1 }} md={{ size: 4, offset: 1 }} sm={{ size: 6, offset: 1 }} xs={{ size: 12, offset: 0 }}  style={{paddingTop:"20px"}}>
						<BottomBar
							// mainButtonOnClick={this.props.nextStage}
							mainButtonOnClick={() => {
								// const proposalDate = moment(this.props.ds360APIResult.proposalDate);
								// const isoSelectedDate = moment(this.state.selectedDate);
								this.props.commonSubmitCallback(this.state.selectedOption)
							}}
							mainButtonTextResource={"ok"}
						/>
					</Col>
				</Row>
			</BrowserView>
		</Container>
    }

}

export default translate("translations")(StageTAM6002Apl03);